import React from 'react'
import capitalize from 'lodash/capitalize'

import { Tag } from 'Shared/atoms'
import { TagType } from 'Shared/atoms'

export type ValidInvalidTagValues = 'VALID' | 'INVALID' | 'APPROVED'

interface ValidInvalidLabelProps {
	value: ValidInvalidTagValues | null
}

const TagMap: { [key in ValidInvalidTagValues]: TagType } = {
	VALID: 'green',
	INVALID: 'red',
	APPROVED: 'blue'
}

const ValidInvalidLabel: React.FC<ValidInvalidLabelProps> = ({ value }) => {
	if (!value) {
		return null
	}
	return (
		<Tag type={TagMap[value]} size="m" isSingle>
			{capitalize(value)}
		</Tag>
	)
}

export default ValidInvalidLabel
